module.exports = __webpack_public_path__ + "static/BarlowSemiCondensed-Regular-ebd90d8e590842539cb812662b79aca2.ttf";